import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IPreheatCollectionCropsV1Request } from './preheat-collection-crops-v1-request';
import type { IPreheatCollectionCropsV1Response } from './preheat-collection-crops-v1-response';
import { preheatCollectionCropsV1ResponseSchema } from './preheat-collection-crops-v1-response';

export async function preheatCollectionCropsV1Api({
  collectionId,
  limit,
}: IPreheatCollectionCropsV1Request): Promise<
  IValidatedResponse<IPreheatCollectionCropsV1Response>
> {
  const query = limit !== undefined ? `?limit=${limit}` : '';
  return postRequest<IPreheatCollectionCropsV1Response>({
    path: `/sys/collections/${collectionId}/triage/preheat-crops/v1${query}`,
    schema: preheatCollectionCropsV1ResponseSchema,
  });
}
